exports = module.exports = require("../../../../../mover/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".controls__2NCPJ {\n  display: grid;\n  grid-gap: var(--uds-space-2);\n  gap: var(--uds-space-2);\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n}\n", ""]);

// Exports
exports.locals = {
	"controls": "controls__2NCPJ"
};